'use client';

import React from 'react';
import useCommonRef, {
  ModalRefOption,
  ModalRef,
  UseCommonRefReturn,
  ResolveCustomMap,
  ResolveVisibleKey,
  ResolveHookOptions,
} from './common';

/**
 * Drawer 类型弹窗 Hook 封装。
 * @param ref - 转发的 ref
 * @param defaultData - 默认数据
 * @param options - Hook 配置
 * @param deps - options 刷新依赖
 * @returns useCommonRef 返回值
 */
function useDrawerRef<
  T extends Record<string, any>,
  U = any,
  C extends Record<string, any> = {},
  VK extends string | undefined = undefined,
  R = unknown,
  const O extends ModalRefOption<'drawer', T, U, C, R> = ModalRefOption<'drawer', T, U, C, R>,
>(
  ref: React.Ref<ModalRef<'drawer', T, U, ResolveCustomMap<C, ResolveHookOptions<O>>, ResolveVisibleKey<VK, ResolveHookOptions<O>>, R>>,
  defaultData: Partial<T> | (() => Partial<T>) = {},
  options?: O,
  deps: React.DependencyList = [],
): UseCommonRefReturn<'drawer', T, U, ResolveCustomMap<C, ResolveHookOptions<O>>, ResolveVisibleKey<VK, ResolveHookOptions<O>>, R> {
  return useCommonRef('drawer', ref, defaultData, options, deps);
}

export default useDrawerRef;
